import {Box, Typography} from '@mui/material';
import './DocumentMediaTranscripts.scss';
import {t} from 'i18next';
import ArrLoadingSpinner from '../../../../../common/arr-loading-spinner/ArrLoadingSpinner';
import {memo} from 'react';

interface DocumentMediaTranscriptsProps {
  transcriptText?: string;
  isTranscriptLoading?: boolean;
  dataTestId: string;
}

const DocumentMediaTranscripts: React.FC<DocumentMediaTranscriptsProps> = memo(
  ({transcriptText = '', isTranscriptLoading, dataTestId}) => {
    return (
      <div
        className="docs-media-transcripts"
        data-testid={`document-media-transcripts-transcript`}
      >
        <Box className={'header-container'}>
          <Typography
            className="typo-text subhead5_size title"
            data-testid={`document-media-transcripts-transcript-text`}
          >
            {t('docTranscripts.transcript')}
          </Typography>
        </Box>
        <Box className={'transcription-container'}>
          <Typography
            className="typo-text body5_size transcription-text"
            data-testid={`document-media-transcripts-transcript-text-${dataTestId}`}
          >
            {transcriptText}
          </Typography>
        </Box>
        <ArrLoadingSpinner isOpen={isTranscriptLoading} overlay={true} />
      </div>
    );
  }
);

export {DocumentMediaTranscripts};
